"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonSquare2 = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const SkeletonSquare2 = ({ ...props }) => ((0, jsx_runtime_1.jsx)(react_content_loader_1.default, { speed: 2, width: 40, height: 40, viewBox: "0 0 40 40", backgroundColor: 'rgb(var(--placeholder-secondary))', foregroundColor: 'rgb(var(--secondary-bg))', ...props, children: (0, jsx_runtime_1.jsx)("circle", { cx: "20", cy: "20", r: "20" }) }));
exports.SkeletonSquare2 = SkeletonSquare2;
